import styled from "styled-components";

export const Container = styled.header`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;

  @media (min-width: 1025px) {
    height: ${({ theme }) => theme.CONSTANTS.XH * 16}px;
    box-shadow: 0 0 12px rgba(0, 0, 0, 0.4);
  }
`;

export const ContainerHeader = styled.header`
  width: 100%;
  max-width: 1440px;
  padding: 10px 4vw;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  @media (min-width: 1025px) {
    padding: 0;
  }
`;

export const LogoWrapper = styled.div`
  z-index: 1;
`;

export const MenuIcon = styled.div`
  position: fixed;
  right: 16px;
  font-size: 28px;
  cursor: pointer;
  z-index: 20;

  @media (min-width: 1025px) {
    display: none;
  }

  img {
    width: 32px;
    height: 32px;
  }
`;

export const MenuOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.THEME.background};
  backdrop-filter: blur(6px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding-top: 40px;
  z-index: 99;

  @media (min-width: 1025px) {
    display: none;
  }
`;

export const MenuContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.CONSTANTS.XH * 3}px;

  a {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 38}px;
    color: ${({ theme }) => theme.THEME.white};
    font-family: "Inter";
    font-weight: 500;
    cursor: pointer;
    text-decoration: none;
    transition: 0.2s ease-in-out;

    &:hover {
      color: ${({ theme }) => theme.THEME.grayText};
      transform: scale(1.05);
    }
  }
`;

export const CloseIcon = styled.div`
  position: absolute;
  top: 85px;
  right: 24px;
  font-size: 2rem;
  color: ${({ theme }) => theme.THEME.white};
  cursor: pointer;
`;

export const MenuDesktop = styled.nav`
  display: none;

  @media (min-width: 1025px) {
    display: flex;
    gap: 2.5rem;
    align-items: center;
    margin-left: auto;

    a {
      font-size: ${({ theme }) => theme.CONSTANTS.XR * 8}px;
      color: ${({ theme }) => theme.THEME.white};
      cursor: pointer;
      transition: 0.2s ease-in-out;

      &:hover {
        color: ${({ theme }) => theme.THEME.grayText};
        transform: scale(1.08);
      }
    }
  }
`;
